<h1 class="pb-5">{{ 'MEDIALIBRARY.title' | translate: {count: 1} }}</h1>
<div class="row">
  <div class="col col-6 col-lg-3 mb-4">
    <div class="upload-container"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
      <label for="file-upload" class="upload-box">
        @if(imagePreview){
          <img [src]="imagePreview"
               alt="Preview"
               class="image-preview"/>
        } @else {
          <div class="upload-text">
            <span class="material-symbols-outlined">cloud_upload</span>
            <p>Drag&Drop or Click to Upload</p>
            <p class="overline">Max Size 2MB</p>
          </div>
        }
        <input id="file-upload" type="file" (change)="addMedia($event)" class="file-input"/>
      </label>
      @if(isLoading){
        <mat-spinner diameter="30" style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%)"></mat-spinner>
      }
    </div>
  </div>

  @for (media of mediaList; track media) {
    <div class="col col-6 col-lg-3 mb-4">
      <div style="width: 100%; aspect-ratio: 4/3; position: relative">
        <img
          [ngSrc]="media.filePath"
          priority
          fill
          (click)="selectImage(media.filePath)">
      </div>
      <div class="py-2 px-3" style="background: white; position: relative">
        <button mat-icon-button
                (click)="confirmDelete(media.fileId, $event)"
                aria-label="Delete"
                class="trailing-end-button">
          <mat-icon>
            <span class="material-symbols-outlined">delete</span>
          </mat-icon>
        </button>
        <span class="overline">Dimension: {{ media.height }} x {{ media.width }}</span><br>
        <span class="overline">File Size: {{  media.size }}</span>
      </div>
    </div>
  }

</div>
